import { useEffect, useState } from 'react';
import { collection, query, orderBy, onSnapshot, doc, deleteDoc } from 'firebase/firestore';
import { Box, Typography, Button, Paper, Stack, Chip, IconButton } from '@mui/material';
import { Add, Edit, Delete } from '@mui/icons-material';
import { db } from './firebase';
import { useAuth } from './AuthContext';
import { ACTIVITY_LABELS } from './constants';
import { fmtDateTime } from './helpers';
import ActivityModal from './ActivityModal';

export default function Attivita() {
  const { staff } = useAuth();
  const [items, setItems] = useState([]);
  const [contatti, setContatti] = useState([]);
  const [modal, setModal] = useState(null);

  const isAdmin = staff?.role === 'admin';

  useEffect(() => {
    const u1 = onSnapshot(query(collection(db, 'crm_attivita'), orderBy('data', 'desc')), s => setItems(s.docs.map(d => ({ id: d.id, ...d.data() }))));
    const u2 = onSnapshot(collection(db, 'crm_contatti'), s => setContatti(s.docs.map(d => ({ id: d.id, ...d.data() }))));
    return () => { u1(); u2(); };
  }, []);

  // Se non è admin, vede solo le sue attività
  const visibleItems = isAdmin ? items : items.filter(a => a.owner === staff?.nome);

  return (
    <Box>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
        <Box>
          <Typography variant="h5" sx={{ fontWeight: 700 }}>Attività</Typography>
          <Typography variant="body2" color="text.secondary">Chiamate, email, WhatsApp, demo, incontri.</Typography>
        </Box>
        <Button variant="contained" startIcon={<Add />} onClick={() => setModal({ tipo: 'call', data: new Date().toISOString().slice(0, 16) })}>Registra</Button>
      </Box>

      <Paper>
        {visibleItems.length === 0 ? <Box sx={{ p: 4, textAlign: 'center', color: 'text.secondary' }}>Nessuna attività.</Box> : visibleItems.map(a => {
          const c = contatti.find(x => x.id === a.contattoId);
          return (
            <Box key={a.id} sx={{ p: 2, borderBottom: 1, borderColor: 'divider', display: 'flex', gap: 2, '&:last-child': { borderBottom: 0 } }}>
              <Box sx={{ flex: 1 }}>
                <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap">
                  <Typography variant="body2" sx={{ fontWeight: 600 }}>{ACTIVITY_LABELS[a.tipo]}</Typography>
                  {c && <Typography variant="body2" color="text.secondary">· {c.nome}{c.azienda ? ' (' + c.azienda + ')' : ''}</Typography>}
                  {a.esito && <Chip label={a.esito} size="small" />}
                </Stack>
                <Typography variant="caption" color="text.secondary">{fmtDateTime(a.data)} · {a.owner}</Typography>
                {a.note && <Typography variant="body2" sx={{ mt: 0.5, whiteSpace: 'pre-wrap' }}>{a.note}</Typography>}
                {a.prossimoStep && <Typography variant="caption" color="primary" sx={{ display: 'block', mt: 0.5 }}>→ {a.prossimoStep}</Typography>}
              </Box>
              <IconButton size="small" onClick={() => setModal(a)}><Edit fontSize="small" /></IconButton>
              <IconButton size="small" onClick={() => window.confirm('Eliminare?') && deleteDoc(doc(db, 'crm_attivita', a.id))}><Delete fontSize="small" /></IconButton>
            </Box>
          );
        })}
      </Paper>

      {modal && <ActivityModal initial={modal} onClose={() => setModal(null)} />}
    </Box>
  );
}